import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import PatientForm from "./PatientForm";
import OTPVerificationPage from "./OTPVerificationPage";
import Loader from "../Common/Loader";
import axiosInstance from "../../../services/AxiosInstance";

const PatientFormWrapper = () => {
  const { formId, patientId } = useParams(); // base64 encoded values

  // Decode once using useMemo
  const decodedFormId = useMemo(() => {
    try {
      return atob(formId);
    } catch {
      return null;
    }
  }, [formId]);

  const decodedPatientId = useMemo(() => {
    try {
      return atob(patientId);
    } catch {
      return null;
    }
  }, [patientId]);

  const [consentRequired, setConsentRequired] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFormDetails = async () => {
      try {
        setLoading(true);

        const response = await axiosInstance.post(`/admin/formDetails`, {
          form_id: decodedFormId,
          patient_id: decodedPatientId, // <-- Now sending patient_id
        });

        const isVerify = response?.data?.data?.is_verify;
        setConsentRequired(isVerify === "No");
      } catch (err) {
        setConsentRequired(false);
      } finally {
        setLoading(false);
      }
    };

    if (decodedFormId && decodedPatientId) {
      fetchFormDetails();
    }
  }, [decodedFormId, decodedPatientId]);

  if (loading) return <Loader />;

  if (consentRequired) {
    return (
      <OTPVerificationPage
        patientId={patientId}      // encoded
        formId={formId}            // encoded
        patient_id={decodedPatientId} // decoded for backend
      />
    );
  }

  return (
    <div className="container mt-5">
      <PatientForm formId={formId} patientId={patientId} />
    </div>
  );
};

export default PatientFormWrapper;
